import { Moon, Sun } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useTheme } from "@/hooks/useTheme";
import { useAuth } from "@/lib/auth";

export function ThemeToggle() {
  const auth = useAuth();
  const { isDark, toggle } = useTheme(auth.user?.dark_mode);

  return (
    <Button variant="outline" size="icon" onClick={toggle} aria-label={isDark ? "Switch to light mode" : "Switch to dark mode"}>
      {isDark ? <Moon className="size-4" /> : <Sun className="size-4" />}
    </Button>
  );
}
